const ARCHIVE_MIME_TYPES = new Set([
  'application/zip',
  'application/x-zip-compressed',
  'application/x-tar',
]);

const ALLOWED_MIME_TYPES = new Set([
  'application/pdf',
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/webp',
  'text/plain',
  'application/json',
  'application/javascript',
  'application/x-javascript',
  'text/javascript',
  'application/typescript',
  'application/xml',
  'text/xml',
  'application/x-httpd-php',
  'application/x-sh',
  'application/x-shellscript',
  'application/sql',
  'application/x-sql',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.ms-excel',
  'application/vnd.ms-powerpoint',
  ...ARCHIVE_MIME_TYPES,
]);

const ALLOWED_EXTENSIONS = new Set([
  '.pdf',
  '.png',
  '.jpg',
  '.jpeg',
  '.gif',
  '.webp',
  '.txt',
  '.text',
  '.md',
  '.markdown',
  '.csv',
  '.tsv',
  '.log',
  '.js',
  '.jsx',
  '.ts',
  '.tsx',
  '.cjs',
  '.mjs',
  '.json',
  '.html',
  '.htm',
  '.css',
  '.scss',
  '.sass',
  '.less',
  '.xml',
  '.yml',
  '.yaml',
  '.toml',
  '.ini',
  '.conf',
  '.config',
  '.env.example',
  '.php',
  '.py',
  '.rb',
  '.java',
  '.c',
  '.cc',
  '.cpp',
  '.h',
  '.hpp',
  '.cs',
  '.go',
  '.rs',
  '.sh',
  '.bash',
  '.zsh',
  '.sql',
  '.docx',
  '.xlsx',
  '.pptx',
  '.xls',
  '.ppt',
  '.zip',
  '.tar',
]);

function lowerExtension(name = '') {
  const lower = String(name || '').toLowerCase();
  if (lower.endsWith('.env.example')) return '.env.example';
  const dot = lower.lastIndexOf('.');
  return dot >= 0 ? lower.slice(dot) : '';
}

export function isArchiveAttachment(file = {}) {
  const name =
    file.uploadName || file.name || file.filename_orig || file.filename || '';
  const mime = String(
    file.type || file.mimetype || file.mime_type || ''
  ).toLowerCase();
  return (
    ['.zip', '.tar'].includes(lowerExtension(name)) ||
    ARCHIVE_MIME_TYPES.has(mime)
  );
}

export function isAllowedAttachmentFile(file = {}) {
  const name =
    file.uploadName || file.name || file.filename_orig || file.filename || '';
  const mime = String(
    file.type || file.mimetype || file.mime_type || ''
  ).toLowerCase();

  if (mime.startsWith('text/') || ALLOWED_MIME_TYPES.has(mime)) return true;
  return ALLOWED_EXTENSIONS.has(lowerExtension(name));
}

export function partitionFilesByAllowedType(files = []) {
  const allowed = [];
  const rejected = [];

  for (const file of files) {
    if (isAllowedAttachmentFile(file)) {
      allowed.push(file);
    } else {
      rejected.push({ file, reason: 'Unsupported attachment type' });
    }
  }

  return { allowed, rejected };
}

export function formatSkippedAttachmentMessage(rejected = []) {
  const names = rejected
    .map((item) => item?.file?.uploadName || item?.file?.name || item?.name)
    .filter(Boolean);

  if (!names.length) return '';
  if (names.length === 1) return `Unsupported attachment skipped: ${names[0]}.`;
  return `Unsupported attachments skipped: ${names.join(', ')}.`;
}
